export default __webpack_public_path__ + "static/media/click-sparks.8cd5e135.svg";